import React from 'react';
import { IconCheck } from '@tabler/icons-react';
import { STEPS_CONFIG } from '../../constants/formConstants';

const StepsNavigation = ({ currentStep, onStepClick }) => {
  return (
    <div className="mpf-steps-nav d-none d-md-flex justify-content-center mb-4">
      {STEPS_CONFIG.map((step, index) => {
        const StepIcon = step.icon;
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isCompleted = currentStep > stepNumber;
        
        return (
          <div
            key={stepNumber}
            className={`mpf-step-item d-flex flex-column align-items-center ${
              isActive ? "text-primary" : isCompleted ? "text-success" : "text-muted"
            }`}
            style={{ cursor: "pointer", minWidth: "120px" }}
            onClick={() => stepNumber < currentStep && onStepClick(stepNumber)}
          >
            <div
              className={`mpf-step-circle rounded-circle d-flex align-items-center justify-content-center mb-2 ${
                isActive
                  ? "bg-primary text-white"
                  : isCompleted
                  ? "bg-success text-white"
                  : "bg-light text-muted"
              }`}
              style={{ width: "40px", height: "40px" }}
            >
              {isCompleted ? <IconCheck size={20} /> : <StepIcon size={20} />}
            </div>
            <small className="text-center mpf-step-label">{step.title}</small>
          </div>
        );
      })}
    </div>
  );
};

export default StepsNavigation;